import src from "IMAGE";
export default { src, width: 1600, height: 568, blurWidth: 0, blurHeight: 0};
